import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { ModalFooter, Row } from 'reactstrap';
import { InfoIcon } from '../../../../shared';
import { UncontrolledTooltip } from 'reactstrap';
import { invoiceStatusDrpdwn, fieldDateFormat, backendDateFormat } from '../../../../constants';
import { FieldInput, FieldLabel, FieldCol, FieldGroup, FieldDate } from '../../Elements';
import { checkValidDate, checkNumber } from '../../../../formValidator';
import { trackActivity } from '../../../../utils/mixpanel';
import { getLocalStorageInfo, showCurrencyFormat } from '../../../../utils';
import { globalGetService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, toastFlashMessage } from '../../../../utils_v2';
import appConfig from '../../../../config';
import { avationPlcInstance, titanInstance } from '../../../../shared_elements/components';
import { jetStreamInstance } from '../../../../lease_management/Leases';
import { getInvoiceStatusTimelineApi } from '../apiServices';

const numberWithDot = /^[0-9]*(\.\d{0,2})?$/;

export default class ChangeInvoiceStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      paid_date: moment().format(backendDateFormat),
      error: {},
      partial_paid_amount: '',
      partial_paid_date: '',
      status_change_reason: '',
      paymentAmounts: [],
      invoiceItemErrors: [],
      invoiceInfo: [],
      offsetError:[],
      statusTimeline:[]
    };
    this.getInvoiceStatusTimelineApi = getInvoiceStatusTimelineApi.bind(this)
    
  }
  componentDidMount() {
    this.getInvoiceDetails()
    this.getOffsetInvoices()
    if(this.props?.invoiceInfo?.id  && this.props?.invoiceInfo){
      this.getInvoiceStatusTimelineApi({...this.props,params:{...this.props.params,id:this.props?.invoiceInfo?.id}})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.invoiceInfo?.assemblies !== this.props.invoiceInfo?.assemblies) ||
      (prevState.status !== this.state.status && this.state.status === 5) ||
      (prevState.status !== this.state.status && this.state.status === 3)
    ) {
      const assemblies = this.props.invoiceInfo?.assemblies || [];
      this.setState({
        paymentAmounts: assemblies.map(a => a.paymentAmount || ''),
      });
    }
  }

  getInvoiceDetails = () => {
    globalGetService(`contracts/${this.props.params.contract_slug}/invoice/${!this.props.islist ? this.props.invoiceInfo.id : this.props.invoiceInfo.id}/`)
      .then(response => {
        if (response?.data?.statusCode === 200) {
          const data = response.data.data;
          this.setState({ invoiceInfo: data });
          trackActivity('Page Visited', {
            page_title: 'Invoice View',
            application_module: 'Contracts',
            item_id: data?.id,
            asset: data.invoice_number,
          });
        }
      })
  };
  getOffsetInvoices =()=>{
    globalGetService(`contracts/${this?.props.params.contract_slug}/invoice/`,{is_offset:true, parent_invoice_type:this.props.invoiceInfo.invoice_type})
    .then(response=>{
      if(checkApiStatus(response)){
        this.setState({offsetInvoice:response.data.data?.invoice_list})
      }
    })
  }

  dropDownChange = (statusOption) => {
    this.setState(prevState => ({
      ...prevState,
      status: statusOption ? statusOption.value : '',
      error: {
        ...prevState.error,
        status: ''
      }
    }));
  }
  onFieldChange = (key, value) => {
    this.setState(prevState => ({
      ...prevState, [key]: value,
      invoiceInfo: {
        ...prevState.invoiceInfo,
        invoice_items: prevState.invoiceInfo.invoice_items.map(item => ({
          ...item, offset_amount: ''
        })
        )
      }
    }))
  }
  updateField = (e) => {
    debugger
    if ((titanInstance || avationPlcInstance)) {
      let setDates = this.state?.statusTimeline?.filter(item => item?.current_status === 'Sent')
      let minDate = setDates?.length ? setDates[setDates?.length - 1]?.date : ''
      if (setDates?.length && minDate && moment(e).isBefore(moment(minDate))) {
        toastFlashMessage(`Please select Paid date greater than or equal to Sent Date : ${minDate}`, 'error');
      }
      else {
        this.setState(prevState => ({
          ...prevState,
          paid_date: e,
          error: {
            ...prevState.error,
            paid_date: ''
          }
        }));
      }
    } else {
    this.setState(prevState => ({
      ...prevState,
      paid_date: e,
      error: {
        ...prevState.error,
        paid_date: ''
      }
    }));
  }
  }
  updateForm = (key, value) => {
    if (key === 'partial_paid_amount') {
      if (numberWithDot.test(value)) {
        this.setState(prevState => ({
          ...prevState,
          partial_paid_amount: value
        }));
      }
    } else {
      debugger
      if ((titanInstance || avationPlcInstance) && key == 'partial_paid_date') {
        let setDates = this.state?.statusTimeline?.filter(item => item?.current_status === 'Sent')
        let minDate = setDates?.length ? setDates[setDates?.length - 1]?.date : ''
        if (setDates?.length && minDate && moment(value).isBefore(moment(minDate))) {
          toastFlashMessage(`Please select Partial Payment date greater than or equal to Sent Date : ${minDate}`, 'error');
        }
        else {
          this.setState(prevState => ({
            ...prevState,
            [key]: value
          }));
        }
      } else {

        this.setState(prevState => ({
          ...prevState,
          [key]: value
        }));
      }
    }
  }

  handlePaymentAmountChange = (index, value, keyParam) => {
    // if (!numberWithDot.test(value) && value !== '') return;
    this.setState(prevState => {
      const invoiceInfo = { ...prevState.invoiceInfo };
      invoiceInfo.invoice_items = invoiceInfo.invoice_items.map((item, idx) => {
        if(keyParam==='offset_amount'){
          this.updateOffsetError()
          if (idx === index) {
            return { ...item, offset_amount: value };
          }
        } else{
          if (idx === index) {
            return { ...item, payment_amount: value };
          }
        }
        return item;
      });
      return { invoiceInfo };
    });
  };

  handleExcessAmountChange = (index, value, keyParam) => {
    this.setState(prevState => {
      const invoiceInfo = { ...prevState.invoiceInfo };
      invoiceInfo.invoice_items = invoiceInfo.invoice_items.map((item, idx) => {
        if(keyParam==='offset_amount'){
          this.updateOffsetError()
          if (idx === index) {
            return { ...item, offset_amount: value };
          }
        } else{
        if (idx === index) {
          return { ...item, excess_amount: value };
        }
      }
        return item;
      });
      return { invoiceInfo };
    });
  };
updateOffsetError =()=>{
  this.setState(prevState=>({
    ...prevState,
    offsetError: ''
  }))
}
  getOffsetValidation = (invoiceItems) => {
    return (invoiceItems.map((item, index) => {
      if (!(item?.remaiming_amount >= parseFloat(item?.offset_amount || 0)) && this.state?.offset_invoice?.invoice_type === 5) {
        return `Please enter amount less than or equal to Remaining Offset Amount US$ ${item?.remaiming_amount}.`;
      } else if (!(item?.item_total_amount >= parseFloat(item?.offset_amount || 0)) && this.state?.offset_invoice?.invoice_type === 5) {
        return `Please enter amount less than US$ ${item?.item_total_amount}.`;
      }
      if ((parseFloat(item?.payment_amount) < parseFloat(item?.offset_amount)) && this.state?.offset_invoice?.invoice_type === 5) {
        return `Please enter amount less than or equal to Payment Amount US$ ${item?.payment_amount}.`;
      }
      if (this.state.offset_invoice?.invoice_items.map(item => item?.reference_id).includes(item?.reference_id)) {
        if ((parseFloat(Math.abs(this.state?.offset_invoice?.invoice_items.find(child => child.reference_id == item?.reference_id)?.remaiming_amount)) < parseFloat(item?.offset_amount))) {
          return `Please enter amount less than or equal to Remaining Offset Amount US$ ${Math.abs(this.state?.offset_invoice?.invoice_items.find(child => child.reference_id == item?.reference_id)?.remaiming_amount)}.`;
        }
      }
      return '';
    }))
  }
  updateInvStatus = () => {
    const invoiceDate = moment(this.state.invoiceInfo?.created_at);
    const newInvoiveDate =appConfig.env.key === "api" ? moment('2025-06-08T00:00:00') : moment('2025-05-26T10:00:00')
    if (!this.state.status) {
      this.setState(prevState => ({
        ...prevState,
        error: {
          ...prevState.error,
          status: 'Please Select the Status First'
        }
      }));
      return;
    }
    if (this.state.status === 3) {
      if (this.state.paid_date && moment(this.state.paid_date).isValid()) {
        let validateTitanOffset = this.getOffsetValidation(this.state.invoiceInfo?.invoice_items)
        if(!titanInstance || Object.keys(validateTitanOffset).every((k) => { return validateTitanOffset[k] === '' })){
          let totalOffsetAmount = (this.state?.invoiceInfo?.invoice_items.reduce((sum,nextItem )=> {return sum + parseFloat(nextItem?.offset_amount || 0) }, 0)).toFixed(2)
        if (invoiceDate.isSameOrAfter(newInvoiveDate )) {
          this.props.updateInvStatus({
            status: this.state.status,
            paid_date: this.state.paid_date,
            status_change_reason: this.state.status_change_reason,
            offset_invoice:this.state?.offset_invoice?.id,
            total_offset_amount: totalOffsetAmount ? parseFloat(totalOffsetAmount) : 0,
            payment_data: this.state.invoiceInfo.invoice_items.map((item,index) => ({
              id: item?.id,
              sub_total: item?.remaiming_amount,
              offset_amount:item?.offset_amount ? parseFloat(item?.offset_amount) : 0,
              offset_id: this.state?.offset_invoice?.invoice_items[index]?.id,
              excess_amount: item?.excess_amount ? parseFloat(item?.excess_amount) : 0
            }))
          });
        } else {
          this.props.updateInvStatus({
            status: this.state.status,
            paid_date: this.state.paid_date
          });
        }
      }
      else{
        this.setState({offsetError:validateTitanOffset})
      }
      } else {
        this.setState(prevState => ({
          ...prevState,
          error: {
            ...prevState.error,
            paid_date: 'Please enter Invoice Payment Date'
          }
        }));
      }
    } else if (this.state.status === 5) {
      let validateNewInput = {
        partial_paid_date: checkValidDate({ value: this.state.partial_paid_date, required: true, minLength: '', maxLength: '', message: 'Please enter Partial Payment Date' }),
        partial_paid_amount: checkNumber({ value: this.state.partial_paid_amount, required: ((this.props.invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2||this.props.invoiceInfo?.invoice_type === 10) ? !invoiceDate.isSameOrAfter(newInvoiveDate) : true) ? true : false, minLength: '', maxLength: '', message: 'Please enter Partial Payment Amount' })
      };
      let validateTitanOffset = this.getOffsetValidation(this.state.invoiceInfo?.invoice_items)

      if ((this.props.invoiceInfo?.total_amount ? this.state.partial_paid_amount > this.props.invoiceInfo?.total_amount : this.state.partial_paid_amount > this.props.totalAmount) ||
        (this.props.totalAmountInv ? this.state.partial_paid_amount > this.props.totalAmountInv : null)) {
        validateNewInput.partial_paid_amount = 'Please enter Partial Payment Amount less than Total Amount';
      }
      if (this.state.partial_paid_amount <= 0 && this.state.partial_paid_amount !== '') {
        validateNewInput.partial_paid_amount = 'Partial Payment Amount should be more than 0';
      }
      if (this.props.invoiceInfo?.partial_paid_amount ? this.state.partial_paid_amount > (this.props.invoiceInfo?.total_amount - this.props.invoiceInfo?.partial_paid_amount) : (this.state.partial_paid_amount > this.props.diff && this.props.totalAmount !== this.props.diff && this.props.diff && this.state.partial_paid_amount !== '') ||
        (this.state.partial_paid_amount > this.props.totalAmountInv && this.props.invoiceInfo.partial_paid_amount != null && this.state.partial_paid_amount !== '')) {
        validateNewInput.partial_paid_amount = 'Please enter Partial Payment Amount less than Remaining Amount';
      }
      if (invoiceDate.isSameOrAfter(newInvoiveDate) && (this.props.invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2)) {
        const totalAmount = this.props.invoiceInfo?.total_amount || 0;
        const totalRemainingAmounts = this.state.invoiceInfo.invoice_items?.reduce((acc, item) => acc + parseFloat(item.remaiming_amount || 0), 0);
        const totalPaymentAmounts = this.state.invoiceInfo.invoice_items?.reduce((acc, item) => acc + parseFloat(item.payment_amount || 0), 0);
        const hasAnyPayment = this.state.invoiceInfo.invoice_items?.some(item => parseFloat(item.payment_amount || 0) > 0);
        if (!hasAnyPayment && (this.props.invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2)) {
          toastFlashMessage('Please enter atleast one Payment Amount', 'error');
          return;
        }
        if (totalPaymentAmounts >= totalRemainingAmounts && this.state.status === 5 && (this.props.invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2)) {
          if(this.props.invoiceInfo?.total_amount===0){
            toastFlashMessage(`Invoice Amounts should not be 0`, 'error')
          }
          toastFlashMessage(`Total of Payment Amounts should not exceed (${(this.props.invoiceInfo?.currency === 'USD' ? 'US$' : '€') + (totalRemainingAmounts - 1)})`, 'error')
          return;
        }
        const invoiceItemErrors = this.state.invoiceInfo.invoice_items?.map((item, idx) => {
          const payment = parseFloat(item.payment_amount || 0);
          const subTotal = parseFloat(item.sub_total || 0);
          if (payment > subTotal && (this.props.invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2)) {
            return 'Payment amount cannot exceed Invoice Amount';
          }
          return '';
        });
        const hasItemErrors = invoiceItemErrors.some(err => err !== '');

        if (hasItemErrors) {
          this.setState({ invoiceItemErrors });
          return;
        } else {
          this.setState({ invoiceItemErrors: [] });
        }
      }
      const totalPaymentAmounts = this.state.invoiceInfo.invoice_items?.reduce((acc, item) => acc + parseFloat(item.payment_amount || 0), 0);

      if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] == "" }) && Object.keys(validateTitanOffset).every((k) => { return validateTitanOffset[k] === '' })) {
        if (invoiceDate.isSameOrAfter(newInvoiveDate) && (this.props.invoiceInfo.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9||this.props.invoiceInfo?.invoice_type === 10 || this.props.invoiceInfo?.invoice_type === 2)) {
          let totalOffsetAmount = (this.state?.invoiceInfo?.invoice_items.reduce((sum,nextItem )=> {return sum + parseFloat(nextItem?.offset_amount || 0) }, 0)).toFixed(2)
          this.props.updateInvStatus({
            status: this.state.status,
            partial_paid_date: moment(this.state.partial_paid_date).format(backendDateFormat),
            partial_paid_amount: totalPaymentAmounts,
            offset_invoice:this.state?.offset_invoice?.id,
            total_offset_amount: totalOffsetAmount ? parseFloat(totalOffsetAmount) : 0,
            payment_data: this.state.invoiceInfo.invoice_items?.map((item, index) => ({
              id: item?.id,
              sub_total: item?.sub_total,
              payment_amount: parseFloat(item?.payment_amount) || 0,
              offset_amount:item?.offset_amount ? parseFloat(item?.offset_amount) : 0,
              offset_id: this.state?.offset_invoice?.invoice_items[index]?.id,
            }))
          });
        } else {
          this.props.updateInvStatus({
            status: this.state.status,
            partial_paid_date: moment(this.state.partial_paid_date).format(backendDateFormat),
            partial_paid_amount: parseFloat(this.state.partial_paid_amount)
          });
        }
      } else {
        this.setState({
          error: validateNewInput,
          offsetError:validateTitanOffset
        });
      }
    } else {
      if (this.state.paid_date) {
        this.props.updateInvStatus({
          status: this.state.status,
          paid_date: this.state.paid_date,
          status_change_reason: this.state.status_change_reason
        });
      } else {
        this.props.updateInvStatus({
          status: this.state.status,
          status_change_reason: this.state.status_change_reason
        });
      }
    }
  }

  render() {
    const { status, invoiceType, invoiceStartDate, invoiceEndDate, totalAmount, invoice, } = this.props;
    const { partial_paid_date, partial_paid_amount, paid_date, invoiceInfo, offset_amount } = this.state;
    const newInvoiveDate =appConfig.env.key === "api" ? moment('2025-06-08T00:00:00') : moment('2025-05-26T10:00:00')
    const invoiceDate = moment(invoiceInfo?.created_at);
    const shouldShowPartialAmount =
      (invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2||this.props.invoiceInfo?.invoice_type === 10)
        ? invoiceDate.isBefore(newInvoiveDate)
        : true;

    let userInfo = getLocalStorageInfo();
    let statusList = [];
    if (parseInt(status) === 1) {
      if ([1, 2, 9, 10].includes(parseInt(invoiceType))) {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1);
      } else {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 5);
      }
    }
    if (parseInt(status) === 2) {
      if ([1, 2, 9, 10].includes(parseInt(invoiceType))) {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 2);
      } else {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 2 && status.value !== 5);
      }
    }
    if (parseInt(status) === 3 && userInfo?.user?.security_groups.map(item => [29, 23].includes(item?.id)).includes(true)) {
      statusList = invoiceStatusDrpdwn.filter(status => status.value === 2);
    }
    if (parseInt(status) === 5 && ((invoiceInfo && invoiceInfo?.partial_payments_applicable === false) || (this.props.invoiceInfo && this.props.invoiceInfo?.partial_payments_applicable === false))) {
      if (userInfo?.user?.security_groups.map(item => [29, 23].includes(item?.id)).includes(true)) {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 5 && status.value !== 4 && status.value !== 6);
      } else {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 2 && status.value !== 5 && status.value !== 4 && status.value !== 6);
      }
    }
    if (parseInt(status) === 5 && ((invoiceInfo && invoiceInfo?.partial_payments_applicable === true) || (this.props.invoiceInfo && this.props.invoiceInfo?.partial_payments_applicable === true))) {
      if (userInfo?.user?.security_groups.map(item => [29, 23].includes(item?.id)).includes(true)) {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 4 && status.value !== 6);
      } else {
        statusList = invoiceStatusDrpdwn.filter(status => status.value !== 1 && status.value !== 2 && status.value !== 4);
      }
    }
    if (parseInt(status) === 6 && jetStreamInstance ) {
      statusList = invoiceStatusDrpdwn.filter(status => ![1,2,4,6].includes(status.value));
    }
      let offsetRef = this.state.offset_invoice?.invoice_items.map(item=> item?.reference_id)    
      console.log('statusTimelinestatusTimeline',this.state.statusTimeline.filter(item => item?.current_status==='Sent'));
    return (
      <div>
        <div style={{padding:'20px', height: this.state.status === 3 && !invoiceDate.isSameOrAfter(newInvoiveDate) ? '300px':'' }}>
          <h5>Update the invoice status as applicable
            <InfoIcon id="updateInvoiceStatus" />
            <UncontrolledTooltip placement="right" target="updateInvoiceStatus">
              Status of the invoice to be updated to reflect on invoice summary.
            </UncontrolledTooltip>
          </h5>
          <Select
            name="form-field-name"
            placeholder='Select Status'
            className="custom-select-block"
            labelKey='label'
            valueKey='value'
            value={this.state.status}
            onChange={this.dropDownChange}
            options={statusList}
          />
          <h6 style={{ position: 'relative', top: '-20px' }} className="error-msg">{this.state.error.status}</h6>
          { titanInstance &&[1,2].includes(invoiceInfo?.invoice_type) && [3,5].includes(this.state.status)?
            <>
            <FieldLabel className="label">Off Setting Credit/Debit Note</FieldLabel>
            <Select
            name='form-field-name'
            label='Offset invoice'
            placeholder='Select Credit/Debit Note'
            className='custom-select-block'
            labelKey='invoice_number'
            valueKey='id'
            value={this.state.offset_invoice || null}
            onChange={(e)=>this.onFieldChange('offset_invoice',e)}
            options={this.state.offsetInvoice}
            /> </>:null
          }
          <Row>
          {
            this.state.status === 3 &&
            <FieldCol md="4">
            <FieldGroup className="form-group" >
            <div>
              <label className="label">Invoice Payment Date</label>
              <DatePicker
                dateFormat={fieldDateFormat}
                selected={this.state.paid_date && moment(this.state.paid_date).isValid() ? moment(this.state.paid_date) : null}
                maxDate={moment()}
                onChange={(e) => this.updateField(moment(e).format(backendDateFormat))}
                showYearDropdown
                showMonthDropdown
                useShortMonthInDropdown
                popperPlacement={'right'}
              />
              <h6 style={{ position: 'relative', top: '-20px' }} className="error-msg">{this.state.error.paid_date}</h6>
            </div>
            </FieldGroup>
            </FieldCol>
          }

          {
            this.state.status === 5 &&<>
              <FieldCol md="4">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Partial Payment Date</FieldLabel>
                  <FieldDate
                    value={partial_paid_date && moment(partial_paid_date).isValid() ? moment(partial_paid_date) : null}
                    type='edit'
                    keyParam="partial_paid_date"
                    updateField={this.updateForm}
                    minDate={moment(invoiceStartDate)}
                    maxDate={moment()}
                    popperPlacement='right'
                    focus={() =>this.setState(prevState => ({error: {...prevState.error,partial_paid_date: ''}}))}
                  />
                  <h6 style={{ position: 'relative', top: '-20px' }} className="error-msg">{this.state.error.partial_paid_date}</h6>
                </FieldGroup>
              </FieldCol>
              {shouldShowPartialAmount ?
                <FieldCol md="6">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Partial Payment Amount</FieldLabel>
                    <FieldInput
                      value={partial_paid_amount}
                      keyParam="partial_paid_amount"
                      updateField={this.updateForm}
                      handleFocus={() =>this.setState(prevState => ({error: {...prevState.error,partial_paid_amount: ''}}))}
                    />
                    <h6 className="error-msg">{this.state.error.partial_paid_amount}</h6>
                  </FieldGroup>
                </FieldCol>  : null}</>
              }
              </Row>
          {
            (this.state.status === 3) && invoiceDate.isSameOrAfter(newInvoiveDate) ? (
              <div className="invoice-payment-table" style={{ marginTop: '20px' }}>
                <table className="common-table">
                  <thead>
                    <tr>
                      <th>Assembly</th>
                      <th>Invoice Amount</th>
                      <th>Paid Amount</th>
                      <th>Excess Amount</th>
                      { titanInstance && this.state.offset_invoice?.id?
                        <th>Offset Amount</th>:null
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceInfo?.invoice_items?.map((assembly, idx) => (
                      <tr key={idx}>
                        <td>{assembly.invoice_item_name || 'N/A'}</td>
                        <td><NumericLabel params={showCurrencyFormat(assembly?.currency)}>{assembly.item_total_amount ? assembly.item_total_amount : '0.00'}</NumericLabel></td>
                        <td><NumericLabel params={showCurrencyFormat(assembly?.currency)}>{assembly.item_total_amount ? assembly.item_total_amount : '0.00'}</NumericLabel></td>
                        {/* { titanInstance && this.state.offset_invoice?.id && this.state.offset_invoice?.invoice_type !== 4?
                        <td><NumericLabel params={showCurrencyFormat(assembly?.currency)}>{assembly.item_total_amount ? assembly.item_total_amount - ( assembly?.offset_amount ? parseFloat(assembly?.offset_amount).toFixed(2) :0) : '0.00'}</NumericLabel> </td> :
                        <td><NumericLabel params={showCurrencyFormat(assembly?.currency)}>{assembly.item_total_amount ?parseFloat(assembly.item_total_amount) + parseFloat( assembly?.offset_amount ? parseFloat(assembly?.offset_amount).toFixed(2) :0) : '0.00'}</NumericLabel></td>} */}
                        <td>
                          <FieldGroup className="form-group">
                            <FieldInput
                              keyParam={`excess_amount_${idx}`}
                              value={assembly.excess_amount || ''}
                              updateField={(key, val) => {
                                const index = parseInt(key.split('_')[2]);
                                this.handleExcessAmountChange(index, val);
                              }}
                              accept="number"
                              maxLength="10"
                              style={{ width: '100px' }}
                            />
                          </FieldGroup>
                        </td>
                        { titanInstance && this.state.offset_invoice?.id?
                          <td>
                        <FieldGroup className="form-group">
                        <FieldInput
                          disable= {offsetRef.includes(assembly?.reference_id) ? false: true}
                          keyParam={`offset_amount`}
                          value={assembly.offset_amount || ''}
                          updateField={(key, val) => { this.handleExcessAmountChange(idx, val, 'offset_amount');}}
                          accept="number"
                          maxLength="10"
                          style={{ width: '100px' }}
                        />
                         {this.state.offsetError[idx] && (<h6 className="error-msg" style={{maxWidth:'230px'}}>{this.state.offsetError[idx]}</h6>)}
                      </FieldGroup> </td>:null}
                      </tr>
                    ))}
                    {titanInstance && this.state.offset_invoice?.id ? <>
                      <tr className="summary-row">
                        <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Offset Amount:</td>
                        <td>
                          <NumericLabel params={showCurrencyFormat(invoiceInfo?.currency)}>
                            {(invoiceInfo?.invoice_items.reduce((sum, nextItem) => { return sum + parseFloat(nextItem?.offset_amount || 0) }, 0)).toFixed(2)}
                          </NumericLabel>
                        </td>
                      </tr>
                      <tr className="summary-row">
                        <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Amount:</td>
                        <td>
                          {(() => {
                            let offsetTotal = parseFloat((invoiceInfo?.invoice_items.reduce((sum, nextItem) => { return sum + parseFloat(nextItem?.offset_amount || 0) }, 0)).toFixed(2) || 0)
                            let totalAmount = parseFloat(invoiceInfo?.invoice_items?.reduce((sum, item) => { return sum + parseFloat(item.item_total_amount || 0); }, 0).toFixed(2) || 0)      
                            return (<>
                              <NumericLabel params={showCurrencyFormat(invoiceInfo?.currency)}>
                                {this.state.offset_invoice.invoice_type === 5 ? (totalAmount - offsetTotal): (totalAmount + offsetTotal)}
                              </NumericLabel> </>)
                          })()}
                        </td>
                      </tr> </>
                      : null}
                  </tbody>
                </table>
              </div>
            ) : null
          }
          {
            (this.state.status === 5) && (invoiceInfo?.invoice_type === 1 || this.props.invoiceInfo?.invoice_type === 9 || this.props.invoiceInfo?.invoice_type === 2||this.props.invoiceInfo?.invoice_type === 10) && invoiceDate.isSameOrAfter(newInvoiveDate) ? (
              <div className="invoice-payment-table" style={{ marginTop: '20px' }}>
                <table className="common-table">
                  <thead>
                    <tr>
                      <th>Assembly</th>
                      <th>Invoice Amount</th>
                      <th>Remaining Amount</th>
                      <th>Payment Amount</th>
                      { titanInstance && this.state.offset_invoice?.id?
                      <th>Offset Amount</th>
                      :null}
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceInfo?.invoice_items?.map((assembly, idx) => (
                      <tr key={idx}>
                        <td>{assembly.invoice_item_name || 'N/A'}</td>
                        <td><NumericLabel params={showCurrencyFormat(assembly?.currency)}>{assembly.item_total_amount ? assembly.item_total_amount : '0.00'}</NumericLabel></td>
                        <td><NumericLabel params={showCurrencyFormat(assembly?.currency)}>{assembly.remaiming_amount ? assembly.remaiming_amount : '0.00'}</NumericLabel></td>
                        <td>
                          <FieldGroup className="form-group">
                            <FieldInput
                              keyParam={`paymentAmount_${idx}`}
                              value={assembly.remaiming_amount === 0 ? 'Paid' : assembly.payment_amount || ''}
                              updateField={(key, val) => {
                                const index = parseInt(key.split('_')[1]);
                                this.handlePaymentAmountChange(index, val);
                              }}
                              disable={assembly.remaiming_amount === 0}
                              accept="number"
                              maxLength="10"
                              style={{ width: '100px' }}
                              handleOnFocus={() => {
                                const newErrors = [...this.state.invoiceItemErrors];
                                newErrors[idx] = '';
                                this.setState({ invoiceItemErrors: newErrors });
                              }}
                            />
                            {this.state.invoiceItemErrors[idx] && (<h6 className="error-msg">{this.state.invoiceItemErrors[idx]}</h6>)}
                          </FieldGroup>
                        </td>
                        { titanInstance && this.state.offset_invoice?.id?
                          <td>
                          <FieldGroup className="form-group">
                          <FieldInput
                              disable= {offsetRef.includes(assembly?.reference_id) ? false: true}
                              keyParam={`offset_amount`}
                              value={assembly.offset_amount || ''}
                              updateField={(key, val) => {
                                const index = parseInt(key.split('_')[1]);
                                this.handlePaymentAmountChange(idx, val, 'offset_amount');
                              }}
                              accept="number"
                              maxLength="10"
                              style={{ width: '100px' }}
                              handleOnFocus={() => {
                                const newErrors = [...this.state.invoiceItemErrors];
                                newErrors[idx] = '';
                                this.setState({ invoiceItemErrors: newErrors });
                              }}
                            />
                              {this.state.offsetError[idx] && (<h6 className="error-msg" style={{maxWidth:'230px'}}>{this.state.offsetError[idx]}</h6>)}
                          </FieldGroup>
                          </td>:null}
                      </tr>
                    ))}
                    <tr className="summary-row">
                    { titanInstance && this.state.offset_invoice?.id? <td></td>:null}
                      <td colSpan="3" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Remaining Amount Payable:</td>
                      <td>
                        <NumericLabel params={showCurrencyFormat(invoiceInfo?.currency)}>
                          {
                            ((invoiceInfo?.invoice_items?.reduce((sum, item) => { return sum + parseFloat(item.remaiming_amount || 0); }, 0)-1).toFixed(2)) || 0
                          }
                        </NumericLabel>
                      </td>
                    </tr>
                    { titanInstance && this.state.offset_invoice?.id?
                    <tr className="summary-row">
                      <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Offset Amount:</td>
                     <td>
                      <NumericLabel params={showCurrencyFormat(invoiceInfo?.currency)}>
                        {
                          (invoiceInfo?.invoice_items.reduce((sum,nextItem )=> {return sum + parseFloat(nextItem?.offset_amount || 0) }, 0)).toFixed(2)
                        }
                      </NumericLabel>

                    </td>
                    
                    </tr>:null}
                    <tr className="summary-row">
                    { titanInstance && this.state.offset_invoice?.id?<td></td>:null}
                      <td colSpan="3" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Payment Amount:</td>
                      <td>
                        <NumericLabel params={showCurrencyFormat(invoiceInfo?.currency)}>
                          {
                            invoiceInfo?.invoice_items?.reduce((sum, item) => {return sum + parseFloat(item.payment_amount || 0);}, 0).toFixed(2)
                          }
                        </NumericLabel>
                      </td>
                    </tr>
                    { titanInstance && this.state.offset_invoice?.id?
                    <tr className="summary-row">
                      <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total Amount:</td>
                      <td>
                        {(()=>{
                        let offsetTotal= (invoiceInfo?.invoice_items.reduce((sum,nextItem )=> {return sum + parseFloat(nextItem?.offset_amount || 0) }, 0)).toFixed(2) || 0
                        let paymentAmount= invoiceInfo?.invoice_items?.reduce((sum, item) => {return sum + parseFloat(item.payment_amount || 0);}, 0).toFixed(2)
                        let DebitTotal = parseFloat(offsetTotal) + parseFloat(paymentAmount)
                        let creditTotal = offsetTotal > 0 ? (parseFloat(paymentAmount)-parseFloat(offsetTotal)) : parseFloat(paymentAmount)
                        return(<>
                        <NumericLabel params={showCurrencyFormat(invoiceInfo?.currency)}>
                          {this.state.offset_invoice.invoice_type === 5 ? creditTotal : DebitTotal}
                        </NumericLabel> </>)
                        })()}
                        </td>
                        </tr>:null}
                  </tbody>
                </table>
              </div>
            ) : null
          }
          {
            userInfo?.user?.security_groups.map(item => [29, 23].includes(item?.id)).includes(true) && this.state.status === 2 && [3, 5].includes(this.props?.status) ?
              <FieldGroup className="form-group">
                <FieldLabel className="label">Reason for Changing Status <span>(Max 250 char)</span></FieldLabel>
                <FieldInput
                  value={this.state.status_change_reason}
                  type='edit'
                  maxLength='250'
                  keyParam="status_change_reason"
                  updateField={this.updateForm}
                />
              </FieldGroup>
              : null
          }

        </div>
        <ModalFooter style={{ position: 'sticky', bottom: '0', backgroundColor: '#fff', padding: '10px 0', textAlign: 'right', }}>
          <div >
            <button className="btn btn-primary" style={{ backgroundColor: '#3f51b5', borderColor: '#3f51b5' }} onClick={() => { this.updateInvStatus(); trackActivity('Invoice Status Changed', { application_module: 'Lease', event_type: 'Clicked on Proceed button', page_title: 'Invoices' }) }} >
              Proceed
            </button>
          </div>
        </ModalFooter>
      </div>
    );
  }
}
